module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-1194w.b1c74836.webp";